import { render } from "./CommentCard.vue?vue&type=template&id=73e9ab1a&ts=true"
import script from "./CommentCard.vue?vue&type=script&lang=ts"
export * from "./CommentCard.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/lizheming/Desktop/workspace/waline/waline/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__